export interface DocSection {
  id: string
  title: string
  group: string
  permission: string | null
}

export const DOCS_GROUPS: Record<string, string> = {
  user_guide: 'Пользователю',
  admin_guide: 'Администратору',
  devops: 'DevOps',
}

export const DOCS_TOC: DocSection[] = [
  { id: 'user_guide/01_roles', title: 'Роли и доступ', group: 'user_guide', permission: null },
  { id: 'user_guide/02_getting_started', title: 'Вход и первые шаги', group: 'user_guide', permission: null },
  { id: 'user_guide/03_projects', title: 'Проекты и документы', group: 'user_guide', permission: null },
  { id: 'user_guide/04_folders', title: 'Папки', group: 'user_guide', permission: null },
  { id: 'user_guide/05_files', title: 'Файлы и версии', group: 'user_guide', permission: null },
  { id: 'user_guide/06_shared', title: 'Доступные мне', group: 'user_guide', permission: null },
  { id: 'user_guide/07_notifications', title: 'Уведомления', group: 'user_guide', permission: null },
  { id: 'user_guide/08_settings', title: 'Настройки профиля', group: 'user_guide', permission: null },

  { id: 'admin_guide/01_monitoring', title: 'Мониторинг', group: 'admin_guide', permission: 'system:health:read' },
  { id: 'admin_guide/02_users', title: 'Пользователи', group: 'admin_guide', permission: 'users:read' },
  { id: 'admin_guide/03_license', title: 'Лицензия', group: 'admin_guide', permission: 'admin:manage' },
  { id: 'admin_guide/04_audit', title: 'Аудит', group: 'admin_guide', permission: 'audit:list' },
  { id: 'admin_guide/05_sessions', title: 'Сессии', group: 'admin_guide', permission: 'admin:manage' },
  { id: 'admin_guide/06_settings', title: 'Настройки системы', group: 'admin_guide', permission: 'admin:manage' },
  { id: 'admin_guide/07_modules', title: 'Модули', group: 'admin_guide', permission: 'admin:manage' },
  { id: 'admin_guide/08_roles', title: 'Роли и разрешения', group: 'admin_guide', permission: 'admin:manage' },
  { id: 'admin_guide/09_jit', title: 'JIT-доступ', group: 'admin_guide', permission: 'admin:manage' },
  { id: 'admin_guide/10_queue', title: 'Очереди и outbox', group: 'admin_guide', permission: 'admin:manage' },

  { id: 'devops/01_deploy', title: 'Развёртывание', group: 'devops', permission: 'admin:manage' },
  { id: 'devops/02_env', title: 'Переменные окружения', group: 'devops', permission: 'admin:manage' },
  { id: 'devops/03_api', title: 'API endpoints', group: 'devops', permission: 'admin:manage' },
]
